import { render, staticRenderFns } from "./ledger.vue?vue&type=template&id=38df0690&scoped=true"
import script from "./ledger.vue?vue&type=script&lang=js"
export * from "./ledger.vue?vue&type=script&lang=js"
import style0 from "./ledger.vue?vue&type=style&index=0&id=38df0690&prod&scoped=true&lang=less"
import style1 from "./ledger.vue?vue&type=style&index=1&id=38df0690&prod&lang=css"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38df0690",
  null
  
)

export default component.exports